module.exports = __webpack_public_path__ + "static/media/icon_close_small.9a97b281.svg";